<template>
  <div>
    <div class="d-flex ga-2 align-center mb-2">
      <span class="label-num">1</span>
      <b>Поданий звітний період</b>
      <span class="text-error">*</span>
    </div>
    <b-autocomplete
      v-model="credentials.previousReportId"
      :items="$directory.get('reportList')"
      placeholder="Оберіть зі списку"
      class="mb-1"
      item-value="id"
      :item-title="r => formatPeriod(r.period, 'locale')"
      hide-details
      :loading="$loading.isLoading('reportList')"
      :error-messages="getErrorMessages(v$.previousReportId)"
      @blur="v$.previousReportId.$touch()">
    </b-autocomplete>
    <div class="text-disabled font-size-14 mb-3">
      Період, який вже було подано раніше і буде базою для порівняння.
    </div>

    <div class="d-flex ga-2 align-center mb-2">
      <span class="label-num">2</span>
      <b>Поточний звітний період</b>
      <span class="text-error">*</span>
    </div>
    <b-autocomplete
      v-model="credentials.currentReportId"
      :items="$directory.get('reportList')"
      placeholder="Оберіть зі списку"
      class="mb-1"
      item-value="id"
      :item-title="r => formatPeriod(r.period, 'locale')"
      hide-details
      :loading="$loading.isLoading('reportList')"
      :error-messages="getErrorMessages(v$.currentReportId)"
      @blur="v$.currentReportId.$touch()">
    </b-autocomplete>
    <div class="text-disabled font-size-14 mb-3">
      Актуальний період, дані якого будуть порівняні з поданим
    </div>

    <div class="d-flex ga-2 align-center mb-2">
      <span class="label-num">3</span>
      <b>Статуси пакетів</b>
      <span class="text-disabled">(необов'язково)</span>
    </div>
    <b-select
      v-model="credentials.statusIds"
      class="mb-1"
      multiple
      hide-details
      :items="$directory.get('packageStatuses')"
      :loading="$loading.isLoading('packageStatuses')">
      <template #prepend-item>
        <v-list-item title="Обрати всі" @click="toggleStatuses">
          <template #prepend>
            <v-checkbox-btn
              :indeterminate="someStatusesSelected && !allStatusesSelected"
              :model-value="allStatusesSelected"></v-checkbox-btn>
          </template>
        </v-list-item>

        <v-divider class="mt-2"></v-divider>
      </template>
    </b-select>
    <div class="text-disabled font-size-14 mb-3">
      Фільтр за статусом пакетів у звіті. Якщо не обрано — будуть включені всі.
    </div>
  </div>
</template>

<script lang="ts">
import { computed, reactive } from 'vue'
import { fillDirectory, getDirectory } from '@/directory'
import { minLength, required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { getErrorMessages } from 'best-modules/utils'
import { analyzeReport } from '@/request/report'
import { formatPeriod } from '@/pages/report/helpers'

export default {
  name: 'ReportAnalyze',
  methods: { getErrorMessages, formatPeriod },
  setup() {
    fillDirectory(['reportList', 'packageStatuses'])

    const credentials = reactive<{
      previousReportId: string
      currentReportId: string
      statusIds: number[]
    }>({
      previousReportId: null,
      currentReportId: null,
      statusIds: [],
    })

    const rules = {
      previousReportId: { required },
      currentReportId: { required },
      statusIds: { minLength: minLength(1) },
    }
    const v$ = useVuelidate(rules, credentials)

    const submit = () => {
      return analyzeReport(credentials)
    }

    const allStatusesSelected = computed<boolean>(() => {
      return (
        credentials.statusIds.length === getDirectory('packageStatuses').length
      )
    })
    const someStatusesSelected = computed<boolean>(() => {
      return !!credentials.statusIds.length
    })

    const toggleStatuses = () => {
      if (allStatusesSelected.value) {
        credentials.statusIds = []
      } else {
        credentials.statusIds = getDirectory('packageStatuses').map(
          s => s.id as number
        )
      }
    }

    return {
      credentials,
      v$,
      submit,
      allStatusesSelected,
      someStatusesSelected,
      toggleStatuses,
    }
  },
}
</script>

<style scoped lang="scss">
.label-num {
  background: rgb(224, 231, 255);
  color: rgb(67, 56, 202);
  font-size: 11px;
  font-weight: 700;
  border-radius: 4px;
  padding: 1px 6px;
  margin-right: 4px;
}
</style>
